
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'
import { useRoute } from 'vue-router'

// Components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// module components
import History from '@/modules/SecurityCheck/components/History/index.vue'

// Types
import { ActivityListT, CarrierT } from '@/core/types/carriers.types'

// Realisation
import { carriers } from '@/core/realisations/carriers.realisation'

// Composable
import useNotifications from '@/common/composable/useNotifications'

import { formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    components: {
        PageTitle,
        Loader,
        TheButton,
        Cheap,
        History,
    },
    setup() {
        const route = useRoute()
        const id = Number(route.params.id as string)

        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            carrier: null as CarrierT | null,
        })

        const loadCarrier = async () => {
            state.carrier = null

            try {
                state.is_loading = true

                const response = await carriers.getCarrier(id)
                state.carrier = response.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true

                notifications.notifyError({
                    title: 'При получении данных произошла ошибка',
                    error,
                })
            } finally {
                state.is_loading = false
            }
        }

        const getActivityString = (activity: ActivityListT[]) => {
            if (!activity) return ''

            let result: string[] = []

            activity.forEach((a) => {
                if (a.activityId === 2) result.push('Перевозчик')
                else if (a.activityId === 3) result.push('Поставщик')
                else if (a.activityId === 4) result.push('Поставщик курьеров')
            })

            return result ? result.join(', ') : ''
        }

        //

        const isHistory = computed(() => {
            return state.carrier && state.carrier.bin
        })

        const getTitle = computed(() => {
            return state.carrier ? `${state.carrier.name} (ID: ${id})` : `(ID: ${id})`
        })

        //

        onBeforeMount(loadCarrier)

        //

        return {
            state,
            id,
            getActivityString,
            //
            isHistory,
            getTitle,
            formatDateFromBackend,
        }
    },
})
